/* eslint-disable import/prefer-default-export */
import { useState } from 'react';
import _noop from 'lodash-es/noop';

import { deleteDocuments } from 'PrivateAPI';

interface UseDeleteParams {
  onError?: (err: unknown) => void;
  onSuccess?: ({ documentId }: { documentId: number }) => void;
}

interface DeleteParams {
  documentId: number;
}

export const useDeleteDocument = ({
  onError = _noop,
  onSuccess = _noop,
}: UseDeleteParams = {}) => {
  const [loading, setLoading] = useState(false);
  const [deletingDocumentId, setDeletingDocumentId] = useState<number | undefined>();

  const deleteDocument = async (deleteParams: DeleteParams) => {
    setLoading(true);

    const documentId = deleteParams?.documentId;

    setDeletingDocumentId(documentId);

    try {
      if (!Number.isInteger(documentId)) {
        throw new Error('Document ID is invalid or not supplied.');
      }

      await deleteDocuments(deleteParams);

      onSuccess?.({ documentId });
    } catch (err: unknown) {
      window?.Sentry?.captureException?.(err);
      onError?.(err);
    } finally {
      setLoading(false);
      setDeletingDocumentId(undefined);
    }
  };

  return {
    deleteDocument,
    deletingDocumentId,
    loading,
  };
};
